export default function Charte() {
  const pdfUrl = "https://www.lavoielactee.ch/website/admin/data/_lavoielactee/documents/doc/charte.pdf";
  return (
    <main className="max-w-5xl mx-auto px-4 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight text-slate-900">Charte</h1>
      <p className="mt-4 text-slate-700">Consultez la charte officielle de l'école ci-dessous ou téléchargez-la.</p>
      <div className="mt-4">
        <a className="inline-block px-4 py-2 rounded-full bg-amber-500 text-white font-semibold hover:bg-amber-600" href={pdfUrl} target="_blank" rel="noreferrer">Télécharger la charte (PDF)</a>
      </div>
      <div className="mt-6 border rounded-xl overflow-hidden">
        <iframe title="Charte PDF" src={pdfUrl} className="w-full" style={{ height: "70vh" }} />
      </div>
    </main>
  );
}